import React from 'react';
import PropTypes from 'prop-types';

const HtmlDynamically = props => (
  <i className={props.className} dangerouslySetInnerHTML={{ __html: props.html }}>
  </i>
);

HtmlDynamically.propTypes = {
  html: PropTypes.any
};

export default HtmlDynamically;
